const { isUndNullEmpNew } = require('../../helpers/UtilsHelper');

export class BotClass {
    constructor(
        id = '',
        accounts = [],
        accountId = '',
        eventId = '',
        message = '',
        moduleId = '',
        name = '',
        order = 0,
        register = new Date().toISOString(),
        status = false,
    ) {
        this.id = id;
        this.accounts = accounts;
        this.accountId = accountId;
        this.eventId = eventId;
        this.message = message;
        this.moduleId = moduleId;
        this.name = name;
        this.order = order;
        this.register = register;
        this.status = status;
    }

    static getClassName = () => {
        return 'Bot - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this?.getClassName(), })?.result) {
            return new BotClass(
                obj.id,
                obj.accounts,
                obj.accountId,
                obj.eventId,
                obj.message,
                obj.moduleId,
                obj.name,
                obj.order,
                obj.register,
                obj.status,
            );
        }

        return new BotClass();
    }
};